import { cn } from '../../lib/utils'

interface FormFieldProps {
  label: string
  name: string
  type?: string
  placeholder?: string
  required?: boolean
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
  error?: string
  as?: 'input' | 'textarea' | 'select'
  options?: { value: string; label: string }[]
}

const FormField = ({
  label,
  name,
  type = 'text',
  placeholder,
  required = false,
  value,
  onChange,
  onBlur,
  error,
  as = 'input',
  options = []
}: FormFieldProps) => {
  const inputBaseStyles = 'w-full px-4 py-3 border-2 border-gray-200 rounded-lg text-base font-sans transition-all duration-200 bg-white focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/10'
  const inputErrorStyles = error ? 'border-red-500' : ''

  return (
    <div className="mb-6">
      <label htmlFor={name} className="block text-sm font-semibold text-gray-900 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      {as === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={cn(inputBaseStyles, inputErrorStyles, 'resize-y min-h-[120px]')}
          required={required}
        />
      ) : as === 'select' ? (
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={cn(inputBaseStyles, inputErrorStyles)}
          required={required}
        >
          <option value="">Selecione...</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={cn(inputBaseStyles, inputErrorStyles)}
          required={required}
        />
      )}
      
      {error && <span className="block mt-2 text-sm text-red-500">{error}</span>}
    </div>
  )
}

export default FormField

